// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Col, Input, Switch, Button, Modal } from 'antd';
import { SaveOutlined, RollbackOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

import Message from 'shared_components/message';
import { createMessagesAPI, getMessagesCodeAPI, searchMessagesAPI, updateMessagesAPI } from 'services/system_setup/message_prompt';
import { createRolesAPI, getRolesNameAPI, searchRolesAPI, updateRolesAPI } from 'services/system_setup/roles';
import { createModulesAPI, getModulesNameAPI, searchModulesAPI, updateModulesAPI } from 'services/system_setup/modules';
import { createAccessTypesAPI, getAccessTypeNameAPI, searchAccessTypesAPI, updateAccessTypesAPI } from 'services/system_setup/access_types';
import { createModuleAccessAPI, searchModuleAccessAPI, updateModuleAccessAPI } from 'services/system_setup/module_access';
import AddRoleAccess from 'modules/system_setup/add_system_setup_values/addRoleAccess';
import { createRoleAccessAPI, updateRoleAccessAPI } from 'services/system_setup/role_access';
import AddModuleAccess from 'modules/system_setup/add_system_setup_values/addModuleAccess';
import { UserAccessContext } from 'context/userAccess';

const { TextArea } = Input;

const AddSetupDetails = (props) => {
    const { userAccess } = useContext(UserAccessContext);
    const updateRight = userAccess['systemSetup'].update;

    const [form] = Form.useForm();
    const { setupDet, drawerValue, drawerClose, refreshTblData, setData } = props;
    const setupDetProps = ( props.tableData === undefined ? [] : props.tableData )
    const isEditting = (props.tableData === undefined ? false : true);
    const [checkVal, setCheckVal] = useState(false);
    const [setupName, setSetupName] = useState('');
    const [desc, setDesc] = useState('');
    const [messType, setMessType] = useState('');
    const [display, setDisplay] = useState('');
    const [accessValues, setRoleAccessValues] = useState([]);
    const [modAccessValues, setModAccessValues] = useState([]);
    const [allDisabled, setAllDisabled] = useState(false)
    // console.log('role accessValues', accessValues)

    const handleSetupName = ()=> {
        if(props.setupDet === 'MESSAGE PROMPTS'){
            setSetupName(setupDetProps.message_code)
            setDesc(setupDetProps.message_description)
            setMessType(setupDetProps.message_type)
            setDisplay(setupDetProps.message_display)
        }
        
        if(props.setupDet === 'ROLES'){
            setSetupName(setupDetProps.role_name)
            setDesc(setupDetProps.role_desc)
        }
        
        if(props.setupDet === 'MODULES'){
            setSetupName(setupDetProps.module_name)
            setDesc(setupDetProps.module_desc)
        }
        
        if(props.setupDet === 'ACCESS TYPES'){
            setSetupName(setupDetProps.access_type_name)
            setDesc(setupDetProps.access_type_desc)
        }
        
        if(props.setupDet === 'MODULE ACCESS'){
            setSetupName(setupDetProps.module_access_code)
            // setDesc(setupDetProps.access_type_desc)
        }
    }

    useEffect(()=> {
        if(isEditting){
            if(updateRight === 'TRUE'){
                setAllDisabled(false)
            }else{
                setAllDisabled(true)
            }
        }
    }, [])

    useEffect(()=> {
        // form.resetFields();
        handleSetupName();
    }, [setupDetProps])

    useEffect(()=> {
        form.resetFields();
        setSetupName(setupName)
    }, [setupName])

    const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

    const moduleAccessValues = (values) => {
        setModAccessValues(values);
    };

    const roleAccessValues = (values) => {
        setRoleAccessValues(values);
    };

    const checkSetupDet = (value) =>{
        switch(value){
            case "MESSAGE PROMPTS": return "MESSAGE CODE";
            case "MODULES": return "MODULE NAME";
            case "MODULE ACCESS": return "MODULE ACCESS CODE";
            default:
                return value + " NAME";
        };
    }

    const getSetupName = (value) => {
        switch (value) {
            case "ROLES": return setupDetProps.role_name;
            case "MODULES": return setupDetProps.module_name;
            case "ACCESS TYPES": return setupDetProps.access_type_name;
            case "MODULE ACCESS": return setupDetProps.module_access_code;
            case "MESSAGE PROMPTS": return setupDetProps.message_code;
            default:
                return value;
        }
    }

    function handleSubmit(formValues){
        if(checkVal){
            Message.error({ message: `${props.setupDet} ALREADY EXISTS.` });
        }else{
            // call modal
            Modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined />,
                content: 'Are you sure you want to continue?',
                okText: 'YES',
                cancelText: 'NO',
                onOk: ()=>{
                    handleConfirm(formValues);
                }
            });
        }
    };

    const handleConfirm = async (formValues) =>{
        const userID = loggedinUser.userID;
        try {
            if(props.setupDet === "MESSAGE PROMPTS"){
                if(isEditting){
                    const res = await updateMessagesAPI(formValues, setupDetProps.message_id, userID);
                    if(res.data.message_id !== undefined){
                        Message.success({ message: 'MESSAGE PROMPT SUCCESSFULLY UPDATED' });
                    }else{
                        Message.success({ message: 'MESSAGE PROMPT ERROR: NOT UPDATED' });
                    }
                    const response = await searchMessagesAPI()
                    setData(response);
                    
                }else{
                    const res = await createMessagesAPI(formValues, userID);
                    if(res.data.message_id !== undefined){
                        Message.success({ message: 'MESSAGE PROMPT SUCCESSFULLY CREATED' });
                    }else{
                        Message.success({ message: 'MESSAGE PROMPT ERROR: NOT CREATED' });
                    }
                }
            }
            
            if(props.setupDet === "ROLES"){
                if(isEditting){
                    console.log('update roles', accessValues)
                    const res = await updateRolesAPI(formValues, setupDetProps.role_id, userID);
                    console.log('res =>', res)
                    if(res.data.role_id !== undefined){
                        console.log('update access =>', accessValues)
                        const resUpdateAccess = await updateRoleAccessAPI(accessValues, setupDetProps.role_id, userID)
                        console.log('resUpdateAccess =>', resUpdateAccess)
                        if(resUpdateAccess.data.module_access_code !== undefined){
                            Message.success({ message: 'ROLE SUCCESSFULLY UPDATED' });
                        }else{
                            Message.error({ message: 'ROLE ACCESS ERROR: NOT UPDATED' });
                        }
                    }else{
                        Message.error({ message: 'ROLES ERROR: NOT UPDATED' });
                    }
                    const response = await searchRolesAPI()
                    setData(response);
                    
                }else{

                    let accessValues = {};

                    for( const[key, value] of Object.entries(formValues)){
                        if(!['description', 'isActive', 'setupName'].includes(key)){
                            let accessValue = value === undefined ? false : value;
                            accessValues[key] = accessValue;
                        }
                    }

                    
                    // console.log('accessList =>', accessList);


                    const res = await createRolesAPI(formValues, userID);
                    if(res.data.role_id !== undefined){
                        const resRoleAccess = await createRoleAccessAPI(formValues, res.data.role_id, userID);
                        if(resRoleAccess.data.module_access_code !== undefined){
                            const resUpdate = await updateRoleAccessAPI(accessValues, res.data.role_id, userID);
                            if(resUpdate.data.module_access_code !== undefined){
                                Message.success({ message: 'ROLE SUCCESSFULLY CREATED' });
                            }else{
                                Message.error({ message: 'ROLE ACCESS ERROR: NOT UPDATED' });
                            }
                        }else{
                            Message.error({ message: 'ROLE ACCESS ERROR: NOT CREATED' });
                        }
                    }else{
                        Message.error({ message: 'ROLE ERROR: NOT CREATED' });
                    }
                }
            }
            
            if(props.setupDet === "MODULES"){
                if(isEditting){
                    const res = await updateModulesAPI(formValues, setupDetProps.module_code, userID);
                    if(res.data.module_code !== undefined){
                        Message.success({ message: 'MODULE SUCCESSFULLY UPDATED' });
                    }else{
                        Message.success({ message: 'MODULE ERROR: NOT UPDATED' });
                    }
                    const response = await searchModulesAPI()
                    setData(response);
                    
                }else{
                    const res = await createModulesAPI(formValues, userID);
                    if(res.data.module_code !== undefined){
                        Message.success({ message: 'MODULE SUCCESSFULLY CREATED' });
                    }else{
                        Message.success({ message: 'MODULE ERROR: NOT CREATED' });
                    }
                }
            }
            
            if(props.setupDet === "ACCESS TYPES"){
                if(isEditting){
                    const res = await updateAccessTypesAPI(formValues, setupDetProps.access_type_code, userID);
                    if(res.data.access_type_code !== undefined){
                        Message.success({ message: 'ACCESS TYPE SUCCESSFULLY UPDATED' });
                    }else{
                        Message.success({ message: 'ACCESS TYPE ERROR: NOT UPDATED' });
                    }
                    const response = await searchAccessTypesAPI()
                    setData(response);
                    
                }else{
                    const res = await createAccessTypesAPI(formValues, userID);
                    if(res.data.access_type_code !== undefined){
                        Message.success({ message: 'ACCESS TYPE SUCCESSFULLY CREATED' });
                    }else{
                        Message.success({ message: 'ACCESS TYPE ERROR: NOT CREATED' });
                    }
                }
            }
            
            if(props.setupDet === "MODULE ACCESS"){
                if(isEditting){
                    const res = await updateModuleAccessAPI(formValues, setupDetProps.module_access_code, userID);
                    if(res.data.module_access_code !== undefined){
                        Message.success({ message: 'ACCESS TYPE SUCCESSFULLY UPDATED' });
                    }else{
                        Message.success({ message: 'ACCESS TYPE ERROR: NOT UPDATED' });
                    }
                    const response = await searchModuleAccessAPI()
                    setData(response);
                    
                }else{
                    const res = await createModuleAccessAPI(formValues, userID);
                    if(res.data.module_access_code !== undefined){
                        Message.success({ message: 'ACCESS TYPE SUCCESSFULLY CREATED' });
                    }else{
                        Message.success({ message: 'ACCESS TYPE ERROR: NOT CREATED' });
                    }
                }
            }
            
            drawerClose(false);
            refreshTblData(true);
            form.resetFields();

        } catch (error) {
            console.log(`${props.setupDet} error`, error);
            Message.error(error);
        }
    };

    const handleBack = () =>{
        // call modal
        Modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined />,
            content: 'Are you sure you want to cancel? All unsaved details will be discarded.',
            okText: 'YES',
            cancelText: 'NO',
            onOk: ()=>{  
                drawerClose(false); 
                form.resetFields(); 
            }
        });
    };
    
    const statusOnChange = (checked)=>{
        console.log("status", checked);
    };

    const handleOnBlur = async (e)=>{
        try {
            let setupNameOnBlur = [];
            if(props.setupDet === "MESSAGE PROMPTS"){
                setupNameOnBlur = await getMessagesCodeAPI(e.target.value);
            }

            if(props.setupDet === "ROLES"){
                setupNameOnBlur = await getRolesNameAPI(e.target.value);
            }

            if(props.setupDet === "MODULES"){
                setupNameOnBlur = await getModulesNameAPI(e.target.value);
            }

            if(props.setupDet === "ACCESS TYPES"){
                setupNameOnBlur = await getAccessTypeNameAPI(e.target.value);
            }
            
            if(setupNameOnBlur.length > 0){
                setCheckVal(true);
                Message.error({ message: `${props.setupDet} ALREADY EXISTS.` });
            }else{
                setCheckVal(false);
            }
        } catch (error) {
            console.log(`${props.setupDet} error`, error);
            Message.error(error);
        }
    }

    const handleFormChange = () =>{
        // console.log('formValues =>', form.getFieldsValue());
        let accessTypes = [];
        let access = {};

        for(const [key, value] of Object.entries(form.getFieldsValue())){
            if(!['description', 'setupName', 'isActive'].includes(key)){
                access[`${key}`] = value;
                // accessTypes.push(access);

                // console.log('key =>', key);
                // console.log('value =>', value);
            }
        }

        roleAccessValues(access);
    }
    
    return(
        <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            onChange={handleFormChange}
        >
            <Row gutter ={[8 , 1]} justify="end">                        
                <Col>
                    <Form.Item name="isActive"  initialValue={(isEditting) ? setupDetProps.is_active : true}>
                        <Switch checkedChildren='Active' unCheckedChildren='Inactive' onChange={statusOnChange}
                        defaultChecked={(isEditting) ? setupDetProps.is_active : true} 
                        disabled={allDisabled}
                        />
                    </Form.Item>
                </Col>
            </Row>
            {(props.setupDet==='MODULES')
                ?   <Row gutter={[8, 1]} justify="space-around" align="top">
                        <Col span={12} >
                            <Form.Item
                                label="MODULE CODE"
                                name="moduleCode"
                                // initialValue={(isEditting) ? setupDetProps.module_code : ''}
                            >
                                <Input type={'text'}
                                    className='inv-input-uppercase'
                                    placeholder='MODULE CODE'
                                    maxLength={50}
                                    defaultValue={(isEditting) ? setupDetProps.module_code : ''}
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item
                                label="SORT"
                                name="moduleSort"
                                initialValue={(isEditting) ? setupDetProps.sort : ''}
                            >
                                <Input type={'number'}
                                    className='inv-input-uppercase'
                                    placeholder='SORT'
                                    maxLength={3}
                                    // onChange={handleSortOnChange}
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
            }
            {(props.setupDet==='ACCESS TYPES')
                ?   <Row gutter={[8, 1]} justify="space-around" align="top">
                        <Col span={24} >
                            <Form.Item
                                label="ACCESS TYPE CODE"
                                name="accessTypeCode"
                                initialValue={(isEditting) ? setupDetProps.access_type_code : ''}
                            >
                                <Input type={'text'}
                                    className='inv-input-uppercase'
                                    placeholder='ACCESS TYPE CODE'
                                    maxLength={50}
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
            }
            <Row gutter={[8, 1]} justify="space-around" align="top">
                <Col span={24} >
                    <Form.Item
                        label={checkSetupDet(props.setupDet)}
                        name="setupName"
                        // initialValue={(isEditting) ? setupName : ''}
                        initialValue={(isEditting) ? getSetupName(props.setupDet) : ''}
                        rules={[ {required: true, message: 'Required Field'} ]}
                    >
                        <Input type={'text'} 
                            className='inv-input-uppercase'
                            placeholder={checkSetupDet(props.setupDet)}
                            maxLength={50}
                            onBlur={handleOnBlur}
                            disabled={ (props.setupDet==='MESSAGE PROMPTS') ? true : false }
                            disabled={allDisabled}
                        />
                    </Form.Item>
                </Col>
            </Row>
            {(props.setupDet==='ROLES')
                ?   <Row gutter={[8, 1]} align='bottom'>
                        <Col className="gutter-row" span={24} >
                            <Form.Item name='description' 
                                label='ROLES DESCRIPTION'
                                initialValue={(isEditting) ? setupDetProps.role_desc : ''}
                            >
                                <TextArea placeholder='Description' disabled={allDisabled}></TextArea>
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
            }
            {(props.setupDet==='MESSAGE PROMPTS')
                ?   <Row gutter={[8, 1]} justify="space-around" align="top">
                        <Col span={24} >
                            <Form.Item
                                label="MESSAGE TYPE"
                                name="messageType"
                                initialValue={(isEditting) ? messType : ''}
                            >
                                <Input type={'text'}
                                    className='inv-input-uppercase'
                                    placeholder='MESSAGE TYPE'
                                    maxLength={50}
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
            }
            {(props.setupDet==='MESSAGE PROMPTS')
                ?   <Row gutter={[8, 1]} justify="space-around" align="top">
                        <Col span={24} >
                            <Form.Item
                                label="MESSAGE DISPLAY"
                                name="messageDisplay"
                                initialValue={(isEditting) ? display : ''}
                            >
                                <TextArea 
                                    className='inv-input-uppercase'
                                    placeholder='MESSAGE DISPLAY'
                                    maxLength={200}
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
            }
            {(props.setupDet==='MODULES')
                ?   <Row gutter={[8, 1]} justify="space-around" align="top">
                        <Col span={24} >
                            <Form.Item
                                label="PATH"
                                name="path"
                                // initialValue={(isEditting) ? messType : ''}
                            >
                                <Input type={'text'}
                                    className='inv-input-uppercase'
                                    placeholder='PATH'
                                    maxLength={100}
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
            }
            {(props.setupDet==='MODULE ACCESS')
                ?   <Row gutter={[8, 1]} justify="space-around" align="top">
                        <Col span={24} >
                            <Form.Item
                                label="MODULE CODE"
                                name="moduleCode"
                                initialValue={(isEditting) ? setupDetProps.module_code : ''}
                            >
                                <Input type={'text'}
                                    className='inv-input-uppercase'
                                    placeholder='MODULE CODE'
                                    maxLength={50}
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
            }
            {(props.setupDet==='MODULE ACCESS')
                ?   <AddModuleAccess  checkSetup='MODULE ACCESS' moduleAccessValues={moduleAccessValues} moduleCode={ props.tableData.module_code } />
                :   <></>
            }
            {(props.setupDet==='ROLES')
                ?   <AddRoleAccess  
                        checkSetup='ROLES' 
                        roleAccessValues={roleAccessValues} 
                        action={props.action} 
                        drawerValue={props.drawerValue}
                        roleData={setupDetProps}
                        form={form}
                    />
                :   <></>
            }
            <Row gutter={[8, 1]} justify='end'>
                <Col style={{marginTop:50}}>
                    <Form.Item>                                
                        <Button 
                            className="inv-button-right" 
                            type="primary" 
                            onClick={handleBack}
                            icon={<RollbackOutlined />}
                        >
                            BACK
                        </Button>
                        <Button 
                            className="inv-button" 
                            type="primary" 
                            htmlType='submit'
                            icon={<SaveOutlined />}
                            disabled={allDisabled}
                        >
                            SAVE
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
};
export default AddSetupDetails;